module.exports = __webpack_public_path__ + "img/lift3.f71d036b.jpg";